<template>
<div class="chapter">
<div class="inner_page">
<h2 class="fmTitle1"><a id="h2"></a><a id="page_7"></a>FOREWORD</h2>
<p class="centera">Captain Keith J Moody (Ret’d)</p>
<p class="paraNoIndent">When I started my flying career as a Pilot in the fifties, I was pleasantly surprised to find myself flying with two women pilots from time to time. These ladies were used on short contract and were ex-Air Transport Auxiliary Pilots from World War II. They did a magnificent job delivering all types of aircraft including fighters and bombers from the aircraft factories to Royal Air Force airfields.</p>
<p class="para">Following on, Yvonne started as a flying instructor. Then, as the first female Ministry civilian Radar Controller, where the ability to think things through clearly was essential, she showed the characteristic determination to succeed, which remained with her even though the chauvinistic attitude of many of her compatriots initially made life difficult for her.</p>
<p class="para">Yvonne Pope Sintes began airline work as a Hostess with British Overseas Airways, learnt to fly with their Airways Aero Club and ended as a Senior Jet Captain with Dan-Air Services, the first woman in Britain to become an Airline Jet Captain.</p>
<p class="para">In 1964, having gained experience and flying hours on the Dakota doing night paper flights, Yvonne managed to persuade Morton Air Services to employ her as a full time First Officer and her flying career ‘took off’!</p>
<p class="para">Having overcome considerable opposition to the hiring of women pilots and also personal tragedy in the death of her first husband the day following the birth of their second son, this lady perpetuates the spirit of the British Air Transport Auxiliary and American Women Air Force Service Pilots.</p>
<p class="para">In 1974, Yvonne received the Whitney Straight Award for her Services to Aviation – recognition of a fight well fought and won!</p>
<p class="para">These days, Yvonne is held in well deserved high esteem and affection by her peers in the aviation world, and personally, my admiration of her many achievements and successes has not diminished in any way over the years I have known her.</p>
<p class="para">This is a fascinating and amazing story and well worth reading!</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 04_foreword.vue?32383e66